import { z } from 'zod';

import { IndustryCode } from '../models/industry-code';
import { ProductCategory } from '../models/product-category';
import { ProductTypeCode } from '../models/product-type-code';
import { ReqServicesType } from '../models/request-services-type';
import { RichTextHeading } from '../models/rich-text-heading';
import { BasePType } from './base';
import { CtaButton } from './cta-button';

export const AddressLookup = BasePType.extend({
  type: z.enum(['requestServices']),
  beforeFormText: z.string(),
  ctaButton: z.array(CtaButton).nullable(),
  industryCode: IndustryCode.nullable(),
  productCategory: z
    .union([z.array(ProductCategory), ProductCategory])
    .nullable(),
  productTypeCode: ProductTypeCode.nullable(),
  reqServicesType: ReqServicesType.nullable(),
  richTextHeading: z.array(RichTextHeading).nullable(),
  showBusinessTypeSelect: z.boolean(),
  showProductAvailability: z.boolean(),
  stacked: z.boolean(),
});

export type AddressLookup = z.infer<typeof AddressLookup>;

export interface AddressRaw {
  id?: string;
  addressHash?: string;
  addressLine1: string;
  addressLine2?: string;
  city?: string;
  countryCode?: string;
  country?: string;
  county?: string;
  display?: string;
  isCloseMatch?: string;
  latitude: number;
  longitude: number;
  locationCode?: string;
  locationConfidenceScore?: string;
  locationType?: string;
  matchConfidenceScore?: string;
  matchType?: string;
  postalCode?: string;
  postalCodeSuffix?: string;
  stateCode?: string;
  timeZoneCode?: string;
  timeZoneName?: string;
}

export interface BusinessIndustryOption {
  tid: string;
  name: string;
  field_industry_code: string;
}
